import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDesignateEmergencySavings = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 320,
	height: 164,
	viewBox: "0 0 320 164",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_0_534)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M215.318 124.54C209.72 128.082 197.102 133.769 181.61 139.839C170.271 144.265 157.397 148.884 144.599 152.978C135.527 155.887 126.491 158.531 118.074 160.663C91.8943 167.293 71.2002 164.483 76.2683 144.054C83.7109 114.126 87.6208 98.1452 85.731 71.4314C84.2676 50.8855 99.8397 42.4373 118.63 44.8882C149.205 48.852 199.028 77.5454 209.963 84.7726C226.118 95.4338 236.322 111.262 215.318 124.54Z",
				className: "brand100",
				fill: "#DFE8FD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M144.595 152.98C157.393 148.886 170.267 144.267 181.606 139.841C172.642 138.036 159.018 136.887 143.76 136.883C116.759 136.883 94.875 140.474 94.875 144.931C94.875 147.387 101.518 149.58 112 151.055L113.5 152.98L118.5 155.637L129 152.608C133.657 152.85 138.615 152.98 143.76 152.98H144.595Z",
				className: "brand300",
				fill: "#2C64EF",
				fillOpacity: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M98.5547 75.2605C108.21 74.5557 120.896 74.3268 128.119 85.7601C144.14 85.9128 156.503 90.9494 166.571 101.629C176.806 101.027 192.881 106.055 197.922 112.905C197.922 112.905 192.172 82.7256 179.517 72.6345C166.863 62.5433 139.826 58.4359 125.969 61.0036C112.111 63.5713 98.5547 75.2605 98.5547 75.2605Z",
				className: "brand300",
				fill: "#2C64EF",
				fillOpacity: .5,
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M137.156 151.299C136.277 151.298 135.434 150.948 134.812 150.326C134.19 149.705 133.84 148.861 133.839 147.982V143.911H133.39C130.155 143.876 126.928 143.585 123.739 143.04C122.953 142.909 122.127 142.743 121.207 142.528L120.664 142.402L120.633 144.647C120.633 145.029 120.55 145.407 120.388 145.754C120.227 146.1 119.992 146.407 119.699 146.653C119.16 147.098 118.481 147.336 117.782 147.327C117.603 147.327 117.424 147.312 117.248 147.282L115.627 147.026C114.848 146.902 114.136 146.512 113.612 145.921C113.088 145.331 112.785 144.578 112.754 143.789V139.264L112.539 139.13C106.928 135.741 103.61 130.493 102.663 123.544L102.618 123.207L102.282 123.158C98.1878 122.566 95.6066 120.061 95.2071 116.286C95.1942 116.132 95.2129 115.978 95.262 115.832C95.3112 115.687 95.3898 115.553 95.4929 115.438C95.596 115.324 95.7215 115.233 95.8615 115.169C96.0015 115.106 96.1531 115.072 96.3069 115.069C96.4543 115.07 96.6 115.101 96.7345 115.161C96.8691 115.222 96.9895 115.309 97.088 115.419C97.5877 115.979 98.2051 116.421 98.8959 116.713C99.5866 117.006 100.334 117.142 101.083 117.111C101.422 117.111 101.761 117.092 102.098 117.053L102.461 117.013L102.497 116.649C103.745 104.013 114.168 93.9261 127.783 92.126C130.061 91.7926 132.359 91.6081 134.66 91.5739L134.889 91.6098L135.087 91.4571C135.657 90.8826 136.268 90.308 136.905 89.7468C136.968 89.6934 137.047 89.6641 137.129 89.6641C137.212 89.6641 137.291 89.6934 137.354 89.7468C138.092 90.3922 138.795 91.077 139.459 91.7983L139.621 91.9734L139.854 91.9375H139.926C140.375 91.9958 140.824 92.0587 141.273 92.1305C144.379 92.5887 147.384 93.5771 150.156 95.0528L150.349 95.156L150.556 95.0663C152.704 94.1614 154.901 93.3761 157.137 92.714L157.249 92.6781L158.959 92.1305C158.995 92.1262 159.031 92.1262 159.067 92.1305C159.14 92.1302 159.211 92.1538 159.269 92.1978C159.313 92.2299 159.349 92.2717 159.374 92.32C159.399 92.3683 159.412 92.4218 159.413 92.4761C159.39 96.0673 158.941 99.0614 158.039 101.634L157.958 101.854L158.097 102.047C159.785 104.399 161.118 106.987 162.052 109.727L162.155 110.028H167.793C168.5 110.028 169.198 110.187 169.835 110.494C170.472 110.8 171.032 111.246 171.473 111.798C171.914 112.351 172.225 112.995 172.383 113.684C172.541 114.373 172.542 115.089 172.386 115.778L171.694 118.813C171.36 120.322 170.631 121.716 169.582 122.853C168.533 123.989 167.202 124.827 165.724 125.281L165.491 125.353L165.428 125.591C164.076 130.949 160.751 135.598 156.118 138.609L155.916 138.739V143.646C155.905 144.374 155.633 145.075 155.15 145.621C154.666 146.166 154.003 146.52 153.281 146.617L151.808 146.788C151.688 146.802 151.566 146.81 151.445 146.81C150.786 146.814 150.149 146.58 149.649 146.151C149.373 145.905 149.153 145.604 149.005 145.266C148.856 144.928 148.782 144.562 148.787 144.193V141.949L148.217 142.11C146.789 142.505 145.34 142.819 143.876 143.049L142.83 143.197L142.224 143.282V147.986C142.223 148.867 141.873 149.71 141.25 150.332C140.627 150.954 139.783 151.304 138.903 151.304L137.156 151.299Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.503 121.311C161.937 121.311 161.78 120.413 161.865 119.641C162.041 118.43 162.288 117.231 162.606 116.05C162.871 115.098 163.504 114.281 163.989 114.281C164.474 114.281 164.734 115.08 164.608 116.027C164.427 117.271 164.163 118.5 163.818 119.708C163.58 120.368 163.064 121.306 162.503 121.311Z",
				className: "brand300",
				fill: "#2C64EF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M166.351 121.265C165.794 121.265 165.646 120.394 165.749 119.604C165.939 118.393 166.2 117.194 166.53 116.013C166.809 115.07 167.428 114.258 167.917 114.258C168.407 114.258 168.645 115.052 168.506 115.991C168.309 117.227 168.032 118.449 167.675 119.649C167.428 120.331 166.907 121.261 166.351 121.265Z",
				className: "brand300",
				fill: "#2C64EF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M160.82 110.352H167.81C168.465 110.352 169.111 110.499 169.702 110.783C170.292 111.067 170.811 111.48 171.219 111.992C171.628 112.504 171.916 113.101 172.063 113.739C172.209 114.378 172.21 115.041 172.065 115.68L171.374 118.714C170.945 120.597 169.89 122.278 168.381 123.484C166.873 124.689 165 125.347 163.069 125.349",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M120.39 138.878L120.318 144.65C120.318 146.203 118.908 147.24 117.292 146.98L115.672 146.724C114.964 146.612 114.316 146.258 113.839 145.723C113.362 145.188 113.085 144.505 113.055 143.788V136.391",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.52175,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M141.864 139.969V147.982C141.864 148.771 141.55 149.528 140.992 150.086C140.434 150.644 139.677 150.958 138.887 150.958H137.159C136.769 150.958 136.382 150.881 136.021 150.731C135.66 150.581 135.332 150.362 135.056 150.086C134.78 149.809 134.561 149.481 134.412 149.12C134.263 148.759 134.187 148.372 134.188 147.982V140.57",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M155.683 138.461V143.646C155.67 144.315 155.419 144.958 154.975 145.459C154.531 145.96 153.922 146.287 153.259 146.379L151.76 146.563C151.419 146.62 151.071 146.601 150.739 146.508C150.406 146.416 150.098 146.252 149.836 146.028C149.574 145.804 149.364 145.525 149.221 145.211C149.078 144.897 149.005 144.556 149.008 144.211V141.639",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M134.048 143.572C130.612 143.577 127.182 143.286 123.796 142.701C122.676 142.518 121.596 142.294 120.555 142.027",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M165.147 125.348C162.498 135.345 154.822 140.96 143.802 142.697C143.151 142.801 142.518 142.89 141.898 142.976",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M152.458 111.4C151.453 111.4 151.111 110.426 150.932 109.645C150.765 108.403 150.887 107.139 151.286 105.95C151.65 105.053 152.283 104.195 153.149 104.195C154.016 104.195 154.505 105.044 154.676 105.942C154.791 107.184 154.67 108.438 154.321 109.636C154.056 110.323 153.459 111.4 152.458 111.4Z",
				className: "brand300",
				fill: "#2C64EF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M161.133 111.4C160.132 111.4 159.787 110.426 159.611 109.645C159.445 108.403 159.566 107.139 159.966 105.95C160.33 105.053 160.963 104.195 161.825 104.195C162.686 104.195 163.203 105.044 163.351 105.95C163.468 107.193 163.348 108.447 162.996 109.645C162.713 110.323 162.139 111.4 161.133 111.4Z",
				className: "brand300",
				fill: "#2C64EF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M129.969 99.4621C131.455 95.9518 133.937 92.8364 137.151 90.0039C139.893 92.4305 142.174 95.332 143.884 98.5688",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M150.5 95.4697C152.902 94.3564 156.039 93.4452 159.087 92.4531C159.087 95.8557 158.638 99.0205 157.628 101.804",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M139.914 92.2734C140.363 92.3318 140.785 92.3946 141.238 92.4665C151.926 94.1364 158.745 100.735 161.932 110.35",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M112.951 138.985C106.348 135.102 102.734 128.598 102.734 119.234C102.734 105.619 113.279 94.383 127.872 92.4617C130.131 92.1325 132.409 91.9496 134.691 91.9141",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.117 106.755C123.929 106.739 123.74 106.762 123.561 106.823C123.382 106.883 123.218 106.979 123.077 107.105C122.937 107.231 122.824 107.385 122.745 107.556C122.666 107.727 122.623 107.913 122.618 108.101L122.564 109.695C118.932 109.834 116.867 111.939 116.778 114.538C116.638 118.578 120.557 119.692 123.376 120.549C125.235 121.133 126.388 121.644 126.357 122.641C126.33 123.48 125.324 124.028 123.794 123.862C122.333 123.698 120.941 123.157 119.754 122.291C119.351 121.991 118.85 121.853 118.351 121.907C117.851 121.96 117.39 122.2 117.06 122.578C116.894 122.808 116.775 123.068 116.711 123.345C116.647 123.621 116.639 123.907 116.688 124.187C116.737 124.466 116.842 124.733 116.996 124.971C117.15 125.209 117.351 125.413 117.586 125.572C118.904 126.481 120.395 127.109 121.967 127.417L121.922 128.674C121.918 129.07 122.059 129.453 122.318 129.752C122.576 130.051 122.935 130.246 123.327 130.299C123.512 130.327 123.7 130.316 123.88 130.265C124.06 130.215 124.227 130.126 124.371 130.006C124.514 129.886 124.63 129.737 124.71 129.568C124.791 129.399 124.835 129.216 124.84 129.029L124.88 127.763C128.768 127.763 130.954 125.815 131.057 122.632C131.187 118.628 127.12 117.398 124.225 116.527C122.299 115.988 121.244 115.58 121.275 114.673C121.275 113.923 121.89 113.38 123.376 113.506C124.637 113.637 125.852 114.05 126.932 114.713C127.339 114.964 127.821 115.065 128.294 114.996C128.767 114.928 129.202 114.696 129.522 114.341C129.718 114.106 129.859 113.829 129.936 113.533C130.012 113.236 130.021 112.926 129.963 112.625C129.904 112.324 129.78 112.04 129.598 111.793C129.416 111.547 129.181 111.343 128.911 111.199C127.842 110.594 126.682 110.166 125.477 109.928L125.531 108.294C125.538 107.905 125.395 107.529 125.131 107.242C124.868 106.956 124.505 106.781 124.117 106.755Z",
				className: "brand300",
				fill: "#2C64EF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M102.652 117.342C100.377 117.683 98.4553 117.4 96.8483 115.654C96.7399 115.54 96.5982 115.463 96.4435 115.434C96.2887 115.406 96.1288 115.427 95.9867 115.495C95.8447 115.562 95.7277 115.673 95.6527 115.812C95.5776 115.95 95.5483 116.109 95.5689 116.265C96.0178 120.332 99.0748 122.504 102.792 122.895",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.58909,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M164.93 54.6992L122.595 150.242C122.313 150.881 121.908 151.459 121.402 151.941C120.896 152.423 120.3 152.8 119.648 153.05C118.996 153.301 118.3 153.419 117.602 153.4C116.903 153.38 116.216 153.222 115.579 152.935V152.935C114.93 152.642 114.348 152.221 113.866 151.697C113.384 151.173 113.013 150.558 112.775 149.887C112.536 149.217 112.435 148.505 112.478 147.795C112.521 147.084 112.707 146.39 113.024 145.753L114.452 142.894",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 4.48895,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M167.922 52.3594C177.268 60.5517 180.94 77.0486 176.693 88.6705L177.142 88.8815C184.863 92.5759 190.129 99.0983 194.496 106.088C195.778 108.208 196.932 110.402 197.953 112.659C198.599 98.3352 195.928 81.9999 188.89 70.0144C184.145 61.9568 177.932 56.4309 169.192 52.8038C168.802 52.6512 168.353 52.521 167.922 52.3594Z",
				fill: "white",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.50829,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M166.866 51.9916C152.47 50.8425 138.136 57.145 131.636 70.4637L131.152 70.32C122.838 67.8511 113.797 69.7634 106.013 72.349C103.506 73.2253 101.058 74.266 98.6875 75.4644C107.912 63.1287 121.092 52.867 136.3 50.2185C145.983 48.5307 155.993 48.4858 165.595 51.5652C166.013 51.6909 166.444 51.839 166.866 51.9916Z",
				fill: "white",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.50829,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M176.657 88.5739C170.668 80.1122 166.179 76.2158 157.861 72.8177C149.956 69.5811 143.712 69.0604 132.723 70.0615C132.368 70.14 132.023 70.2606 131.695 70.4206C131.785 70.2141 131.879 70.0076 131.978 69.7966C137.778 57.7124 151.056 51.4593 164.047 51.9485C165.147 51.989 166.292 52.0428 167.391 52.1506C168.354 52.8739 169.255 53.6756 170.085 54.5476C178.089 62.9824 180.634 77.7151 176.657 88.5739Z",
				fill: "white",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M229.312 34.3951L239.08 24.3398",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M196.188 68.4932L224.876 38.9648",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M200.922 88.9887L243.814 44.8398",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M145.633 26.1961L162.448 8.88672",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M119.562 53.0423L136.221 35.8945",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M206.25 38.4373L234.346 9.51953",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M191.461 53.6692L199.855 45.0234",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M190.367 26.4544L214.168 1.94922",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M171.273 46.1021L181.831 35.2344",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M177.203 53.7224L204.523 25.1367",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M152.672 44.8408L195.564 0.6875",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M210.242 97.5586C211.837 99.0006 212.983 100.87 213.546 102.945",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M200.703 94.716C202.072 94.5035 203.467 94.5369 204.824 94.8147",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M105.093 50.3711C103.494 50.5299 101.935 50.9738 100.492 51.6819",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M114.494 54.6982C113.525 52.566 111.496 51.1879 109.062 50.6133",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M111.183 40.8887C109.437 39.34 107.238 38.4108 104.836 38.7429",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M115.101 48.1679C114.91 46.8205 114.485 45.5169 113.844 44.3164",
				className: "brand300",
				stroke: "#2C64EF",
				strokeWidth: 1.37811,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_0_534",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 169,
			height: 163.865,
			fill: "white",
			transform: "translate(75.5)"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgDesignateEmergencySavings);
export { ForwardRef as ReactComponent };
